import { useMemo } from 'react';
import { entityRoomKeyFromEntityRef } from '@/state/player/perform-control-ws.store';
import { useLivePlayStateWsStore } from '@/state/player/live-play-state-ws.store';
import { mergeLivePlayStateFromWs } from '@/helpers/merge-live-play-state.helper';
import type { LiveContextStateDto } from '@/state/queries/player/use-get-live-context-state';

/**
 * Live context state with on-air preview layers taken from the `live-context-play-state` websocket
 * when it is newer than the last GET — the websocket lands together with the players' show command,
 * the GET only after the following `live-context-invalidated` round trip.
 */
export function useLiveContextStateWithLivePlayState(
  entityRef: string | undefined,
  liveContextState: LiveContextStateDto | undefined,
): LiveContextStateDto | undefined {
  const roomKey = entityRef ? entityRoomKeyFromEntityRef(entityRef) : null;
  const wsEntry = useLivePlayStateWsStore((s) => (roomKey ? s.playStateByRoom[roomKey] : undefined));

  return useMemo(() => mergeLivePlayStateFromWs(liveContextState, wsEntry), [liveContextState, wsEntry]);
}
